exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".branch-coin-pull-report hr.remove-bottom-margin {\n  margin-bottom: 0px !important; }\n\n.branch-coin-pull-report .logo-section {\n  padding-right: 5px;\n  height: 30px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/coin_pull_report/coin_pull_report.scss
// module id = 1026
// module chunks = 1